import { connect } from 'react-redux';
import { getFolderStream, getHasOnlyOneChunkOfGroupFoldersToLoad, } from '../../redux/selectors';
var mapStateToProps = function (state, ownProps) {
    var _a = getFolderStream(state, ownProps.deviationId, ownProps.submissionType, ownProps.groupId), streamId = _a.streamId, folders = _a.folders, isFetching = _a.isFetching, hasMore = _a.hasMore;
    var hasOnlyOneChunkOfGroupFoldersToLoad = getHasOnlyOneChunkOfGroupFoldersToLoad(state, ownProps.submissionType, ownProps.groupId);
    return {
        streamId: streamId,
        folders: folders,
        isFetching: isFetching,
        hasMore: hasMore,
        hasOnlyOneChunkOfGroupFoldersToLoad: hasOnlyOneChunkOfGroupFoldersToLoad,
    };
};
export default connect(mapStateToProps);
//# sourceMappingURL=FolderList.container.js.map